import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"icon-edit\"><path d=\"M5.478 2.128l2.188 2.247L2.188 10H0V7.753l5.478-5.625zm.625-.641L7.366.189a.625.625 0 0 1 .896 0l1.315 1.35a.625.625 0 0 1 0 .874l-1.286 1.32-2.188-2.246zm-.845 7.262h4.117a.625.625 0 0 1 0 1.251H4.632a.366.366 0 0 1-.258-.625l.442-.442a.625.625 0 0 1 .442-.184z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol